import * as z from "zod";

export const getRithumIntegration = {
  name: "getRithumIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    enabled: z.boolean().nullish(),
    profileCount: z.number().nullish(),
  }),
};
